<template>
    <div>
        <vbl-nav>
            <vbl-nav-item to="/vblNav">首页</vbl-nav-item>
            <vbl-nav-item to="/detail">详情页</vbl-nav-item>
            <vbl-nav-item to="/edit">编辑</vbl-nav-item>
        </vbl-nav>
    </div>
</template>

<script>
export default {
};
</script>



// WEBPACK FOOTER //
// vblNavExample.vue?007f38c2